/**
 * Organization Entities - Betrieb Müller
 *
 * Business partners as Digital Twin entities: cooperatives, traders, farms, processors.
 */

import type { MockEntity } from '@hofsync/design-system';
import { daysAgo } from '../farm-profile';

export const ORG_RAIFFEISEN: MockEntity = {
  id: 'org-raiffeisen',
  type: 'organization',
  name: 'Raiffeisen Waren-Zentrale Rhein-Main eG',
  status: 'active',
  lastUpdated: daysAgo(3),
  properties: {
    name_short: 'RWZ Rhein-Main',
    org_type: 'cooperative',
    address: 'Friedberger Landstr. 300, 60389 Frankfurt am Main',
    tax_id: 'DE 114 117 200',
    gln: '4388840000001',
    spent_last_year: 18420.60,
    spent_ytd: 4836.90,
    revenue_last_year: 0,
    revenue_ytd: 0,
  },
  documents: [],
};

export const ORG_BAYWA: MockEntity = {
  id: 'org-baywa',
  type: 'organization',
  name: 'BayWa AG Niederlassung Mainz',
  status: 'active',
  lastUpdated: daysAgo(10),
  properties: {
    name_short: 'BayWa Mainz',
    org_type: 'cooperative',
    address: 'Rheinallee 85, 55120 Mainz',
    tax_id: 'DE 811 164 394',
    gln: '4388840000002',
    spent_last_year: 9750.00,
    spent_ytd: 2180.40,
    revenue_last_year: 0,
    revenue_ytd: 0,
  },
  documents: [],
};

export const ORG_FRUTANIA: MockEntity = {
  id: 'org-frutania',
  type: 'organization',
  name: 'FRUTANIA GmbH',
  status: 'active',
  lastUpdated: daysAgo(5),
  properties: {
    name_short: 'FRUTANiA',
    org_type: 'processor',
    address: 'Heinrich-Lanz-Str. 3, 53501 Grafschaft',
    tax_id: 'DE 813303632',
    gln: '4250632900001',
    spent_last_year: 0,
    spent_ytd: 0,
    revenue_last_year: 156800.00,
    revenue_ytd: 44417.96,
  },
  documents: [],
};

export const ORG_GETREIDEHANDEL_MUELLER: MockEntity = {
  id: 'org-getreidehandel-mueller',
  type: 'organization',
  name: 'Getreidehandel Müller & Söhne',
  status: 'active',
  lastUpdated: daysAgo(15),
  properties: {
    name_short: 'Müller & Söhne',
    org_type: 'trader',
    address: 'Bahnhofstr. 7, 55232 Alzey',
    spent_last_year: 0,
    spent_ytd: 0,
    revenue_last_year: 31560.00,
    revenue_ytd: 0,
  },
  documents: [],
};

export const ORG_GUT_SONNENBERG: MockEntity = {
  id: 'org-gut-sonnenberg',
  type: 'organization',
  name: 'C. & W. Meller GbR — Gut Sonnenberg',
  status: 'active',
  lastUpdated: daysAgo(3),
  properties: {
    name_short: 'Gut Sonnenberg',
    org_type: 'farm',
    address: 'Gut Sonnenberg 1, 50259 Pulheim Stommeln',
    tax_id: '208/5947/0438',
    spent_last_year: 0,
    spent_ytd: 0,
    revenue_last_year: 0,
    revenue_ytd: 0,
  },
  documents: [],
};

export const ORG_ROSENBAUM: MockEntity = {
  id: 'org-rosenbaum',
  type: 'organization',
  name: 'Rosenbaum Fruchtimport & Logistik GmbH',
  status: 'active',
  lastUpdated: daysAgo(8),
  properties: {
    name_short: 'Rosenbaum',
    org_type: 'logistics',
    address: 'Am Eifeltor 16, 50997 Köln',
    spent_last_year: 0,
    spent_ytd: 0,
    revenue_last_year: 0,
    revenue_ytd: 0,
  },
  documents: [],
};

export const ORG_AGRAR_AKTIV: MockEntity = {
  id: 'org-agrar-aktiv',
  type: 'organization',
  name: 'Agrar Aktiv GmbH',
  status: 'active',
  lastUpdated: daysAgo(30),
  properties: {
    name_short: 'Agrar Aktiv',
    org_type: 'contractor',
    address: 'Auf der Heide, 54472 Hochscheid',
    tax_id: '43/659/01647',
    iban: 'DE70 5706 9144 0001',
    bic: 'GENODED1KHK',
    spent_last_year: 2935.25,
    spent_ytd: 6950.79,
    revenue_last_year: 0,
    revenue_ytd: 0,
  },
  documents: [],
};

export const ORG_KUMM_AGRAR: MockEntity = {
  id: 'org-kumm-agrar',
  type: 'organization',
  name: 'Michael Kumm GmbH',
  status: 'active',
  lastUpdated: daysAgo(60),
  properties: {
    name_short: 'Kumm Agrar',
    org_type: 'contractor',
    address: 'Mehrbachstraße 5, 57635 Hasselbach',
    tax_id: '02/650/1114/0',
    iban: 'DE10 5735 1030 0050 0057 27',
    bic: 'MALADE51AKI',
    spent_last_year: 5170.00,
    spent_ytd: 0,
    revenue_last_year: 0,
    revenue_ytd: 0,
  },
  documents: [],
};

export const ORG_MASCHINENRING: MockEntity = {
  id: 'org-maschinenring-rae',
  type: 'organization',
  name: 'MR Rhein-Ahr-Eifel e.V.',
  status: 'active',
  lastUpdated: daysAgo(14),
  properties: {
    name_short: 'MR Rhein-Ahr-Eifel',
    org_type: 'contractor',
    address: 'Robert-Bosch-Str. 9, 56743 Mendig',
    spent_last_year: 0,
    spent_ytd: 5967.67,
    revenue_last_year: 0,
    revenue_ytd: 0,
  },
  documents: [],
};

export const ALL_ORGANIZATIONS: MockEntity[] = [
  ORG_RAIFFEISEN,
  ORG_BAYWA,
  ORG_FRUTANIA,
  ORG_GETREIDEHANDEL_MUELLER,
  ORG_GUT_SONNENBERG,
  ORG_ROSENBAUM,
  ORG_AGRAR_AKTIV,
  ORG_KUMM_AGRAR,
  ORG_MASCHINENRING,
];

export function getOrganizationById(id: string): MockEntity | undefined {
  return ALL_ORGANIZATIONS.find(o => o.id === id);
}
